import * as types from '../types';

export default {
  [types.GET_CLUE_LIST](state, data) {
    state.clueListData = data;
  },
  [types.GET_CLUE_SALESMAN](state, data) {
    state.allSalesman = data.data;
  },
  [types.GET_CLUE_DETAIL](state, data) {
    state.detail = data;
  },
  [types.GET_SEARCH_CUSTOMER](state, data) {
    state.searchCustomerList = data;
  },
  [types.GET_TRANSFER_DETAIL](state, data) {
    state.transferDetail = data;
  },
  [types.GET_CLUE_VISIT](state, data) {
    state.clueVisit = data;
  },
};
